// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaser":"teaser_us_d2xTeaser__x9ByI"};